module.exports = __webpack_public_path__ + "x.no2.ed42a626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/x.no2.jpg
// module id = 8NeQ
// module chunks = 0